module.exports = __webpack_public_path__ + "img/octopus_half.a11e782d.svg";